/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Error_Ratelimit1Inputs */

const en_lib_error_ratelimit1 = /** @type {(inputs: Lib_Error_Ratelimit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've reached the maximum number of requests allowed. Please try again later.`)
};

/**
* | output |
* | --- |
* | "You've reached the maximum number of requests allowed. Please try again later." |
*
* @param {Lib_Error_Ratelimit1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_error_ratelimit1 = /** @type {((inputs?: Lib_Error_Ratelimit1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Error_Ratelimit1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_error_ratelimit1(inputs)
});
export { lib_error_ratelimit1 as "lib.error.rateLimit" }